import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetProductById } from '../../hooks/products/useGetProductById';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import FormAddEditProduct from '../../components/products/Form/FormAddEditProduct';
import LoadingPage from '../../components/global/LoadingPage';
import EmptyContent from '../../components/global/EmptyContent';

const EditProduct = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const isArabic = i18n.language.startsWith('ar');

    const { product, isLoading, error } = useGetProductById(id);

    if (isLoading) return <LoadingPage />;

    if (error || !product) return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <EmptyContent
                title={isArabic ? 'المنتج غير موجود' : 'Product Not Found'}
                description={isArabic ? 'عذراً، لم نتمكن من العثور على المنتج المطلوب' : 'Sorry, we couldn\'t find the requested product'}
            />
        </WrapperSection>
    );

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProduct
                isEdit={true}
                currentData={product}
                onSubmitSuccess={() => navigate('/products')}
            />
        </WrapperSection>
    );
};

export default EditProduct;
